var CrmActivity = $.extend(false, BaseModule ,{
    api_route : 'crm/activity',
	data : {
				module:'crm-activity',
				offset:20,
				page:0,
				sort_term:'id',
				sort_way:'DESC',
				status:'',
				type:''
			},

    load_stats_list:function(page,project_id,additionals){
        var module_name = this.data.module,
            module = this,
            request_data = $.extend(false, additionals || {}, module.data);
        request_data.module  = module_name.split('-')[0];
        request_data.action  = "load-"+module_name+"-list";
        request_data.page = page || 0;
        request_data.project_id = project_id;
        request_data.data_type = 'html';

        $('.'+module_name+'-stats-list').html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span>');

        $.ajax({
            data:request_data,
            dataType:'html',
            success:function(data){
                $('.'+module_name+'-stats-list').html(data);
                initForm('.'+module_name+'-stats-list');
            }
        });
    },

	
	init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    CrmActivity.init();
});
